//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- Start
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BzCard, BzChip, BzInputText, BzScrollContainer } from '../../../../../components';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ORDER_TYPES, ORDERS_TABKEY, TL_INDEX, SESSION_STORAGE_KEYS, EXCHANGE_NAME_LIVEPULSE } from '../../../../../utils/global_variables';
import { StatusChip } from '../../../../Orders';
import ZeroStates from '../../../../ZeroStates';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { useUnload, useWFHMessages } from '../../../../../hooks';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { ordersFilters } from '../../../../../controllers/netPosition';
import { updateFilters } from '../../../../../redux/actions/orders';
import { _getOrderDisplayStatus } from '../../../../../controllers';
import moment from 'moment';
import { handleScripUnsubScriptionOnUnMount } from '../../../../../utils/global_functions';

const MultiLeg = () => {
    const dispatch = useDispatch();


    let containerRef = useRef();
    const [arrOrders, setArrOrders] = useState([]);
    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(false);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    const modalData = useSelector(state => state.modals?.modalData);
    const arrMultilegAllOrders = useSelector(state => state?.orders?.arrMultilegAllOrders); //Ajitesh 15-07-2024 - Multileg Pagination for sidebar

    useEffect(() => {
        setArrOrders(arrMultilegAllOrders)
    },[arrMultilegAllOrders])


    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(false);
    };

    useEffect(() => {
        if (arrMultilegAllOrders?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = arrMultilegAllOrders.filter((each) => each.spread_symbol?.toLowerCase().includes(searchText?.toLowerCase()));
                setArrOrders(filteredPositions);
            } else {
                setArrOrders(arrMultilegAllOrders);
            }
        } else { }
    }, [searchText, arrMultilegAllOrders]);

    const handleMultiScripLtp = useCallback((arrTouchLineData) => {
        let copyArrOrders = [...arrOrders];
        if (arrOrders && arrOrders?.length > 0) {
            arrOrders?.forEach((each, i) => {
                if (each?.segment_id + "_" + each.spread_token + "_" + each?.order_id === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN] + "_" + each?.order_id) {
                    const objScripToBeUpdated = each;
                    objScripToBeUpdated.ltp = arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE];
                    if (Object.keys(objScripToBeUpdated)?.length > 0) {
                        copyArrOrders[i] = objScripToBeUpdated;
                        setArrOrders([...copyArrOrders]);
                    } else { }
                } else { }
            });
        } else { }
    }, [arrOrders]);

    useWFHMessages('touchline', (e) => {
        const arrTouchlineReq = [...e.detail];
        handleMultiScripLtp(arrTouchlineReq);
    });

    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start
    // Adds proper filter names for all segments on UI; so NSE_CUR -> NSECDS, NSE_FO -> NSE; when filter applied values will be compared using what is shown on UI using global variable
    const allExchangeList = [...new Set(arrMultilegAllOrders?.map(element => EXCHANGE_NAME_LIVEPULSE[element?.exchange]))];
    const allProductType = [...new Set(arrMultilegAllOrders?.map(element => element?.exchangeWiseProductType ? element?.exchangeWiseProductType : element?.prod_type))];
    // Vinit R : 12-03-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings -- Start
    const orderStatusFilters = [...new Set(arrMultilegAllOrders?.map(orders => _getOrderDisplayStatus(orders?.status)))];

    const handleFilters = () => {
        if (arrMultilegAllOrders?.length) {
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Orders', allExchangeList: allExchangeList, allProductType: allProductType, orderStatusFilters, isAllowedBuy: false, isAllowedAmnt: false }));
        }
    };

    // Ajitesh: Function to handle filtration in sidetray orderbook for multileg
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined && Object?.keys(modalData?.filter)?.length) {
            let filteredArray = ordersFilters(modalData?.filter, arrOrders);
            if (searchText?.length > 0) {
                filteredArray = filteredArray?.filter((each) => {
                    const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                    let strRowData = each?.spread_symbol + each?.exchange;
                    return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                })
            }
            return filteredArray;
        }
        else {
            if (searchText?.length > 0) {
                const filteredPositions = arrOrders?.filter((each) => {
                    const keywords = searchText?.toString()?.toLowerCase()?.split(' ');
                    let strRowData = each?.spread_symbol + each?.exchange;
                    return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
                });
                return filteredPositions;
            }
            else {
                return arrOrders;
            }
        }
    }, [modalData, searchText, arrOrders])

    useEffect(() => {
        if(filteredData?.length) {
            handleSideBArMultilegOrders();
        }
    }, [filteredData])

    const navigate = useNavigate();
    const handleRedirectMultiLegOrder = (id) => {
        let path = `/orders?section=${ORDER_TYPES.MULTI_LEG}&ordertype=${ORDERS_TABKEY.ALL_ORDERS}`;
        navigate(path, { state: id });
        sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };

    const startObserving = () => {
        return new Promise((resolve) => {
            const observer = new IntersectionObserver((entries) => {
                const visible = entries?.filter((entry) => entry?.isIntersecting)?.map((entry) => entry?.target?.id);
                resolve(visible);
            }, {
                root: containerRef?.current,
                threshold: 0.1
            });
            const container = containerRef?.current;
            if (container) {
                Array?.from(container?.children[0].children[0]?.children[0]?.children[0]?.children)?.forEach((child) => observer?.observe(child));
            }
        });

    };

    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleSideBArMultilegOrders = useCallback(async () => {
        let dahsboardWatchlistData = await startObserving();
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]

            const arrVisibleRows = dahsboardWatchlistData.map(item => {
                let id = item;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true });

                }
                return { exchangeId: Number(item?.split("_")[0]), token: Number(item?.split("_")[1]), isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                if (arrVisibleRows.length > 0) {
                    arrVisibleRows?.forEach((each) => {
                        const arrLastTickData = objLastTickData[each?.exchangeId + "_" + each?.token];
                        if (arrLastTickData?.length > 0) {
                            handleMultiScripLtp(arrLastTickData);
                        }
                    });
                }
            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, []);

    const handleScrollOfOrders = useCallback(() => {
        handleSideBArMultilegOrders();
    }, [handleSideBArMultilegOrders]);

    const handleSideMultilegUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'Side bar single scrip');
    }, [objScripsRequest]);


    useUnload(() => {
        handleSideMultilegUnSubscription();
    });

    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 h_40'>
                    <Col md={9} className='d-flex align-items-center'>
                    {
                        isSearchShoing ?
                            <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search here" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                            </>
                            : null
                    }
                    </Col>
                    {/* <Col md={3} className='d-flex justify-content-start align-items-center'>&nbsp;</Col> */}
                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                        <div onClick={() => arrMultilegAllOrders?.length ? setIsSearchShowing(true) : null} className={`icon-16 icon-search ${arrMultilegAllOrders?.length ? 'icon-dark' : 'icon-grey'}`}></div>
                        <div className={`icon-16 icon-searchfilter ${arrMultilegAllOrders?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=multi_leg'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
            </Container>
            {/* //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : End */}
            {arrMultilegAllOrders?.length > 0 ?
                <Container fluid className='p-0'>
                    <BzScrollContainer className='sticky-orderpositions-height px-3' onScrollEnd={(e) => handleScrollOfOrders(e)} contaierref={containerRef}>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap mb-2'>
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData?.length > 0 ? filteredData?.map((each, i) => (
                                            <>
                                                <BzCard key={i} id={each?.segment_id + '_' + each?.spread_token} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleRedirectMultiLegOrder(each?.order_id)}>
                                                    <Row className='g-0'>
                                                        <Col md={6} className='d-flex justify-content-start align-items-center'>
                                                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.spread_symbol}</div>
                                                            <div className='chips-wrap'>
                                                                <BzChip className='exchange-chip me-2'>{each?.exchange === "NSE_CUR" ? "NSECDS" : each?.exchange === "BSE_CUR" ? 'BSECDS' : each?.exchange.split('_')[0]}</BzChip> {/**Ajitesh 26-07-2024 Adds condition to show NSECDS and BSECDS for currency derv in sidetray orderbook */}
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='orderstatus-chips-wrap d-flex justify-content-end align-items-center'>
                                                            <div className='chips-wrap'>
                                                                <StatusChip data={each} strClass='d-flex justify-content-end align-items-center' />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {/* // Parshva S : 2/4/2024 : BT:102679 Multileg Orders Start  */}
                                                    <Row className='g-0 mb-1'>
                                                        <Col className='d-flex'>
                                                            {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.MktSegId + '_' + each?.scripToken) ?
                                                                <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}
                                                            <div className='font-regular font-size2 color-subtext text-uppercase'>{moment(each?.leg_no_1?.expiry_date).format("DD MMM 'YY")?.toUpperCase()} {each?.leg_no_1?.instrument?.slice(0, 3)}</div>

                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0 mb-1'>
                                                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                            <BzChip className="chips primary-chip me-1">{each?.leg_indicator === "2L" ? "2 Leg" : "3 Leg"}</BzChip>
                                                            <BzChip className="chips primary-chip">Multileg</BzChip>
                                                        </Col>
                                                    </Row>
                                                    <Row className='g-0'>
                                                        <Col md={6} className='d-flex justify-content-start align-self-center'>
                                                            <div className='d-flex align-self-center font-regular font-size1 color-subtext me-2'>{moment(each?.order_modified_timestamp).format("hh:mm:ss A, DD MMM 'YY").toUpperCase()}</div>
                                                        </Col>
                                                    </Row>
                                                    {/* // Parshva S : 2/4/2024 : BT:102679 Multileg Orders End  */}
                                                </BzCard>
                                            </>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </BzScrollContainer>
                </Container>
                :
                <div className='zero-state-alerts zero-state-alerts-xl'>
                    <ZeroStates subText="No orders available" icon='icon-100 icon-nodata mb-2 mrgauto' />
                </div>
            }
        </>
    );
};

export default memo(MultiLeg);
//Mahesh S : 17-08-2023 : BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings- End
